import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import { makeStyles } from '@material-ui/core/styles';
import StartingForm from '../../components/StartingForm';
import Welcome from '../../components/Welcome';
import PageWrapper from '../../components/PageWrapper';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(7),
  },
}));

const Home = ({ verbStore }) => {
  const {
    setAmount,
    amount,
    setSelectedTenses,
    resetVerbList,
    includeTu,
    toggleIncludeTu,
    regularOnly,
    toggleRegularOnly,
    irregularOnly,
    toggleIrregularOnly,
  } = verbStore;

  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    resetVerbList();
  }, []);

  return (
    <PageWrapper>
      <Grid xs={12} md={6} item>
        <Welcome />
      </Grid>
      <StartingForm
        setSelectedTenses={setSelectedTenses}
        setAmount={setAmount}
        amount={amount}
        includeTu={includeTu}
        toggleIncludeTu={toggleIncludeTu}
        regularOnly={regularOnly}
        toggleRegularOnly={toggleRegularOnly}
        irregularOnly={irregularOnly}
        toggleIrregularOnly={toggleIrregularOnly}
      />
      <Fab
        variant="extended"
        color="primary"
        className={classes.fab}
        onClick={() => navigate('/conjugate')}
      >
        Start Practice
      </Fab>
    </PageWrapper>
  );
};

export default inject('verbStore')(observer(Home));